import { IUser } from '../../models/user'

import { IAccessManagementState } from './models'

export const emptyUser: IUser = {
  id: '',
  email: '',
  firstName: '',
  lastName: '',
  countries: [],
  country: '',
  languages: [],
  language: '',
  locales: [],
  locale: '',
  markets: [],
  market: '',
  hpOrgs: [],
  hpOrg: '',
  roles: [],
  password: '',
}

export const initialState: IAccessManagementState = {
  selectedUser: emptyUser,
  isNewUser: true,
}
